import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-tooltip',
    standalone: true,
    imports: [],
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.css'
})
export class TooltipComponent {

  @Input()
  public tooltipTitle: string = '';

}
